import { render, staticRenderFns } from "./add-applicant-svg.vue?vue&type=template&id=6d1b0e39&scoped=true"
import script from "./add-applicant-svg.vue?vue&type=script&lang=js"
export * from "./add-applicant-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1b0e39",
  null
  
)

export default component.exports